import { LegalEntitiesIdentitiesService_legalEntitiesQueryServiceV2PostQuery } from '@festina/legalentity-general-types/legalentity/hooks/LegalEntitiesIdentitiesService_legalEntitiesQueryServiceV2PostQuery'

export const useFetchIdentificationMap =
  LegalEntitiesIdentitiesService_legalEntitiesQueryServiceV2PostQuery.useSuspenseQuery
